import styled from 'styled-components';

export const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  // height: 87vh;
  flex: 1;
  border-bottom: 0.5px solid #f1f3f5;

  .title {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
  }

  .elements {
    display: flex;
    gap: 4px;

    .input {
      height: 36px;
      padding: 8px 12px;
      border-radius: 4px;
      border-color: #ced4da;

      &.error {
        border-color: red !important;
      }

      input {
        height: 100%;
        font-size: 14px;
        font-weight: 400;
        color: #000;
      }
    }
  }
`;

export const FormElement = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;

  .amount {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%;
  }

  .label {
    font-size: 14px;
    font-weight: 600;
    display: flex;
    align-items: center;

    .checkbox {
      margin-top: 2px;
    }
  }

  .required {
    color: red;
  }

  .input {
    height: 36px;
    padding: 0 8px;

    &.error {
      border-color: red !important;
    }
  }

  .tabs {
    display: flex;
    align-items: center;
    gap: 4px;

    button {
      width: 89px;
    }

    .tab {
      border: 1px solid #f1f3f5;
      background-color: #f1f3f5;
    }
  }
`;

export const Footer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  background-color: white;
`;

export const Table = styled.table`
  width: 100%;
  border: 1px solid #f1f3f5;
  border-radius: 8px 8px 0 0 !important;
  // overflow: hidden;
`;

export const TableHeader = styled.thead`
  width: 100%;
  background-color: #f8f9fa;

  tr {
    th {
      padding: 10px 8px;
      color: #868e96;
      font-size: 11px;
      font-style: normal;
      font-weight: 700;
      line-height: 140%;
      letter-spacing: 0.04em;
      text-transform: uppercase;
      text-align: left;
      border-right: 1px solid #f1f3f5;
      vertical-align: middle;

      &:nth-child(3) {
        min-width: 170px;
        text-align: center;
      }
      &:nth-child(4) {
        min-width: 150px;
        text-align: center;
      }

      &:nth-child(8) {
        width: 40px;
        text-align: center;
      }

      .regulator {
        width: 100%;
        display: flex;
        gap: 8px;

        .count {
          color: #adb5bd;
        }
      }
    }
  }
`;

export const TableBody = styled.tbody`
  width: 100%;

  tr {
    td {
      border: 1px solid #f1f3f5;
      padding: 8px 12px;
      // width: 50%;

      &:nth-child(5) {
        max-width: 300px;
      }

      &.not_included {
        background-color: #f9fafb;
      }

      .label {
        display: flex;
        align-items: center;
        gap: 8px;
        color: #000;

        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 19.6px */

        .checkbox {
          margin-top: 2px;
        }
      }

      .reporting {
        width: 100%;
        // max-width: 78px;
        display: flex;
        justify-content: center;
      }

      &.regulator {
        padding: 8px 12px;
        color: #000;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 140%;
      }
    }
  }
`;

export const TableBodyFormPF = styled(TableBody)`
  tr {
    transition: background-color 0.1s ease;

    &:hover td:not(.not_included) {
      background-color: #f8f9fa;
    }

    td {
      vertical-align: middle;

      &:nth-child(8) {
        width: 40px;
        text-align: center;
      }
    }
  }
`;

export const Badge = styled.button`
  border-radius: 4px;
  border: 1px solid #228be6;
  background: #fff;
  padding: 12px 12px 12px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  width: auto;
  align-self: flex-start;

  span {
    color: #25262b;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%; /* 19.6px */
  }
`;

export const SelectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  .label {
    color: #25262b;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 140%; /* 19.6px */

    .checkbox {
      margin-top: 2px;
    }
  }
`;

export const Actions = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 20px;

  .add {
    color: #228be6;
  }

  .delete {
    display: flex;
    align-items: center;
    color: #fa5252;
    gap: 8px;

    svg {
      path {
        fill: #fa5252;
      }
    }
  }
`;

export const BottomActions = styled.div`
  width: 100%;
  display: flex;

  button {
    padding: 0 16px;
    border: 1px solid #228be6;
    border-radius: 4px;
    color: #228be6;
    display: flex;
    gap: 8px;
    color: #228be6;
    align-items: center;
    height: 32px;
  }
`;
